const modalEventFunction = (dialogToShow, modalClass, closeModal) =>{

    const modalToShow = document.querySelector(modalClass)    
    const modalToClose = modalToShow.querySelector(closeModal)

    dialogToShow.addEventListener('click', event =>{
        modalToShow.show();
    })

    modalToClose.addEventListener('click', event =>{
        modalToShow.close()
    })
}

export default modalEventFunction
